export default __webpack_public_path__ + "static/media/img_fee_80.2d6f0c10.svg";